
import HeaderWithVideo from '~/components/planted/HeaderWithVideo'
import IntroducingMyProgram from '@/components/planted/IntroducingMyProgram.vue'
import YouDreamOfBeingHealthy from '@/components/planted/YouDreamOfBeingHealthy.vue'
import TheRightPlace from '@/components/planted/TheRightPlace.vue'
import HowWouldItFeelTo from '@/components/planted/HowWouldItFeelTo.vue'
import TheAnswerIsSimple from '@/components/planted/TheAnswerIsSimple.vue'
import ThereIsABetterWay from '@/components/planted/ThereIsABetterWay.vue'
import IncaseWeHaventMet from '@/components/planted/IncaseWeHaventMet.vue'
import YourVibrantDreamLife from '@/components/planted/YourVibrantDreamLife.vue'
import IllBeStraightWithYou from '@/components/planted/IllBeStraightWithYou.vue'
import NoMore from '@/components/planted/NoMore.vue'
import WhatIsPlanted from '@/components/planted/WhatIsPlanted.vue'
import PlantedGivesYou from '@/components/planted/PlantedGivesYou.vue'
import MyClientsJoin from '@/components/planted/MyClientsJoin.vue'
import ClientTestimonialsLarge from '@/components/planted/ClientTestimonialsLarge.vue'
import ProgramOutline from '@/components/planted/ProgramOutline.vue'
import EatingPBAllowedMeTo from '@/components/planted/EatingPBAllowedMeTo.vue'
import ByCompletingThisProgram from '@/components/planted/ByCompletingThisProgram.vue'
import YouGotBonuses from '@/components/planted/YouGotBonuses.vue'
import GetInstantAccessTo from '@/components/planted/GetInstantAccessTo.vue'
import ANoteFromFiona from '@/components/planted/ANoteFromFiona.vue'
import WonderingIfPlantedIsRightForYou from '@/components/planted/WonderingIfPlantedIsRightForYou.vue'
import FAQs from '@/components/planted/FAQs.vue'
import WhatOthersAreSaying from '@/components/planted/WhatOthersAreSaying.vue'
import TheOldMethod from '@/components/planted/TheOldMethod.vue'
import TheOldMethodLeadsToRegressionAndBurnout from '@/components/planted/TheOldMethodLeadsToRegressionAndBurnout.vue'
import GetInstantAccessToNoTop from '@/components/planted/GetInstantAccessToNoTop.vue'
import GetInstantAccessToGreenBottom from '@/components/planted/GetInstantAccessToGreenBottom.vue'

export default {
  name: 'PlantedLandingPage',
  components: {
    GetInstantAccessToGreenBottom,
    GetInstantAccessToNoTop,
    TheOldMethodLeadsToRegressionAndBurnout,
    TheOldMethod,
    WhatOthersAreSaying,
    FAQs,
    WonderingIfPlantedIsRightForYou,
    ANoteFromFiona,
    GetInstantAccessTo,
    YouGotBonuses,
    ByCompletingThisProgram,
    EatingPBAllowedMeTo,
    ProgramOutline,
    ClientTestimonialsLarge,
    MyClientsJoin,
    WhatIsPlanted,
    NoMore,
    IllBeStraightWithYou,
    YourVibrantDreamLife,
    IncaseWeHaventMet,
    ThereIsABetterWay,
    TheAnswerIsSimple,
    HowWouldItFeelTo,
    TheRightPlace,
    YouDreamOfBeingHealthy,
    IntroducingMyProgram,
    HeaderWithVideo,
    PlantedGivesYou,
  },
  layout: 'plantedlandingpage',
  data() {
    return {
      title: `PLANTED - ${this.$config.siteTitle}`,
      description:
        'PLANTED is a step-by-step system designed to help you master a plant-based diet, achieve your health goals, and change your life in ways you never imagined possible.',
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
        { hid: 'og:title', property: 'og:title', content: this.title },
        { hid: 'og:url', property: 'og:url', content: this.pageUrl },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.description,
        },

        // twitter card
        { hid: 'twitter:title', name: 'twitter:title', content: this.title },
        { hid: 'twitter:url', name: 'twitter:url', content: this.pageUrl },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: this.description,
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: '/images/planted/og.png',
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          content: '/images/planted/og.png',
        },
        {
          hid: 'og:image:width',
          name: 'og:image:width',
          content: '1280',
        },
        {
          hid: 'og:image:height',
          name: 'og:image:height',
          content: '720',
        },
      ],
    }
  },
}
